export default __webpack_public_path__ + "static/media/ds.dd669588.webp";